import React, { useEffect, useState } from 'react';
import { Select, notification } from 'antd';
import { usePedido } from '../../services/usePedidos';
//import {reducerPedidoTypes} from '../../../store/reducer-pedido';
import { useSelector, useDispatch } from 'react-redux';

const StatusPedido = (props) => {
    const {pedido} = props;
    const { listaStatus, atualizaPedido } = usePedido();
    const [statusPossiveis, setStatusPossiveis] = useState([]);
    const [atualizando, setAtualizando] = useState(false);
    const reducerPedido = useSelector((state) => state.reducerPedido);
    const dispatch = useDispatch();

    useEffect(() => {
        carregaStatus();
    }, []);

    const carregaStatus = async () => {
        const status = await listaStatus();
        setStatusPossiveis(status);
    }

    const handleChange = async (value) => {
        setAtualizando(true);
        let hasError = false;
        let novoPedido;
        try {
            pedido.status = value;
            novoPedido = await atualizaPedido(pedido);

            
        } catch (e) {
            console.log(e); 
            hasError= true;
            notification.error({
                message: "Erro ao Atualizar Status",
                description: "O Status do pedido não foi alterado.",
                placement: 'bottomRight'
            });
        } finally {
            if(!hasError){

                notification.success({
                    message: 'Status Atualizado',
                    description: "O Status do pedido foi alterado.",
                    placement: 'bottomRight'
                })
                dispatch({ type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido });
            }

            setAtualizando(false);
        }
        

    };

    const options = () => {
        return statusPossiveis.map((status) => {
            if (status.slug != "EXCLUIDO") {
                return <Select.Option key={status.slug} value={status.slug}>{status.descricao}</Select.Option>
            }
            return (<></>);

        });
    }

    if (pedido.status != "RASCUNHO" && pedido.status && statusPossiveis.length) {

        return (<Select defaultValue={pedido.status}
            loading={atualizando}
            value={pedido.status}
            style={{ width: '100%', float: 'right', marginTop: "0px" }}
            onChange={handleChange}
            size="small"

        >
            {options()}
        </Select>)
    } else if (pedido.status === "RASCUNHO") {
        return <p style={{ textAlign: 'right', color: "gray", float: "right" }}> RASCUNHO&nbsp;</p>
    } else {
        return <>{pedido.status}</>;
    }
    // if(pedido.status === "RASCUNHO"){
    //     return <p style={{textAlign: 'right', color: "gray", float: "right"}}> RASCUNHO&nbsp;</p>
    // } else if(pedido.status === "ABERTO") {
    //     return <p style={{textAlign: 'right', color: "green", float: "right"}}> Aberto&nbsp;</p>
    // } 
    // return <></>;
}

export { StatusPedido };